module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', {
    staticClass: "white--text ma-1",
    attrs: {
      "rounded": "",
      "width": "260px",
      "color": "instagram"
    },
    on: {
      "click": _vm.connectInstagram
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "white",
      "medium": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v("Connect with instagram\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97458a46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/influencer/ConnectInstagram.vue
// module id = 2242
// module chunks = 0